









































import { GPageBase } from '@/mixins';
import { mixins } from 'vue-class-component';
import { Component, Watch } from 'vue-property-decorator';
import { MetaAwarenessGrowthQuestion } from '@/models/jgrow/survey-answer';
import { surveyAnalyzeModule } from '@/store/modules/frames/survey-analyze.module';
import GTitleBar from '@/components/GTitleBar.vue';
import GSurveyAggressiveEntry from './GSurveyAggressiveEntry.vue';
import GLoading from '@/components/GLoading.vue';
import GSurveyChartCircle from './GSurveyChartCircle.vue';
import GSurveyMetaawarenessAnalyze from './GSurveyMetaawarenessAnalyze.vue';
import GSurveyChart from './GSurveyChart.vue';
import GSurveySelectActivityAnalyze from './GSurveySelectActivityAnalyze.vue';
import GSurveyChartLikert from './GSurveyChartLikert.vue';
import { JgrowEventLikertScale } from '@/models/jgrow/jgrow-event-likert-scale';

@Component({
  name: 'GSurveyAnswerAggregate',
  components: {
    GLoading,
    GSurveyChartCircle,
    GSurveyAggressiveEntry,
    GSurveyMetaawarenessAnalyze,
    GTitleBar,
    GSurveyChart,
    GSurveySelectActivityAnalyze,
    GSurveyChartLikert,
  },
  computed: {},
  methods: {},
})
export default class GSurveyAnswerAggregate extends mixins(GPageBase) {
  get metaAwarenessGrowthQuestions(): MetaAwarenessGrowthQuestion[] {
    return surveyAnalyzeModule.metaAwarenessGrowthQuestions;
  }

  get totalUserCount(): number {
    return surveyAnalyzeModule.totalUser;
  }

  get hasLikertScale(): boolean {
    return surveyAnalyzeModule.likertScales.length > 0;
  }

  get likertScales(): JgrowEventLikertScale[] {
    return surveyAnalyzeModule.likertScales.sort((a, b: JgrowEventLikertScale) => a.ID - b.ID);
  }

  competencyName(competencyID: number): string {
    return surveyAnalyzeModule.competencyNameMap.get(competencyID);
  }
}
